import React from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import TreasureGenerator from '../treasure-generator/TreasureGenerator';
import DiceRoller from '../dice-roller/DiceRoller';
import DamageTypeRoller from '../item-helpers/DamageTypeRoller';
import AmmunitionTypeRoller from '../item-helpers/AmmunitionTypeRoller';
import ArmorRoller from '../item-helpers/ArmorRoller';
import WeaponRoller from '../item-helpers/WeaponRoller';
import SpellRoller from '../item-helpers/SpellRoller';
import ItemContentRoller from '../item-helpers/ItemContentRoller';
import SpecialFeaturesRoller from '../item-helpers/SpecialFeaturesRoller';
import DefaultPage from '../DefaultPage';
import TravelPlanner from '../travel-planner/TravelPlanner';

class App extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/treasure-generator" component={TreasureGenerator} />
          <Route path="/dice" component={DiceRoller} />
          <Route path="/item-helpers/damage-type" component={DamageTypeRoller} />
          <Route path="/item-helpers/ammunition" component={AmmunitionTypeRoller} />
          <Route path="/item-helpers/armor" component={ArmorRoller} />
          <Route path="/item-helpers/weapon" component={WeaponRoller} />
          <Route path="/item-helpers/spell" component={SpellRoller} />
          <Route path="/item-helpers/item-content" component={ItemContentRoller} />
          <Route path="/item-helpers/special-features" component={SpecialFeaturesRoller} />
          <Route path="/travel-planner" component={TravelPlanner} />
          <Route component={DefaultPage} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/site/App.js